<template>
  <article class="panel change-message-text-modal">
    <message-box
      v-if="currentAction === 'editMessageText'"
      title="Edit timeline entry"
      submit-text="Save Edited Message"
      type="orange"
      :disable-submit="false"
      @on-close="$emit('on-close-message-visibility-modal')"
      @on-cancel="$emit('on-close-message-visibility-modal')"
      @on-submit="submitTimelineEntry"
    >
      <div class="message-contents-field">
        <NrFormLabel>Message contents</NrFormLabel>
        <nr-editor
          v-model="message"
          :resizable="false"
          :placeholder="'Type your message here or select a template above.'"
          :rows="15"
          strike
          bulletList
          orderedList
          link
        />
        <p class="is-size-7 m-bottom-12">
          {{ footerText }}
        </p>
      </div>
    </message-box>
  </article>
</template>

<script>
import MessageBox from '@nextrequestco/components/src/components/MessageBox'
import NrEditor from '@nextrequestco/components/src/components/NrEditor'
import NrFormLabel from '@nextrequestco/components/src/components/form-elements'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ChangeMessageVisibilityModal',
  components: {
    MessageBox,
    NrEditor,
    NrFormLabel
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    selectedMessage: {
      type: Object
    }
  },
  mounted() {
    this.message = this.selectedMessage.timeline_display_text
  },
  data() {
    return {
      message: ''
    }
  },
  computed: {
    ...mapGetters('request_show', ['request', 'currentAction']),
    footerText() {
      if (this.selectedMessage.timeline_name === 'Note') {
        return 'Editing a timeline entry does not send an email notification.'
      } else {
        const messageVisible =
          this.selectedMessage.timeline_state === 'Staff Only'
            ? 'staff'
            : 'the requester and staff'
        return `This message will be visible to ${messageVisible}. Editing
       a message does not send a new email notification and only updates the timeline.`
      }
    }
  },
  methods: {
    ...mapActions('request_show', ['updateMessage']),
    submitTimelineEntry() {
      if (this.message === this.selectedMessage.timeline_display_text) {
        this.$toasted.success('Timeline entry updated successfully.')
        this.$emit('on-close-message-visibility-modal')
        this.visibility = ''
        return
      }
      const payload = {
        request_event_id: this.selectedMessage.timeline_id,
        request_id: this.request.pretty_id,
        note_text: this.message
      }
      this.updateMessage(payload)
        .then(() => {
          this.$toasted.success('Timeline entry updated successfully.')
          this.$emit('on-close-message-visibility-modal')
          this.visibility = ''
        })
        // eslint-disable-next-line no-unused-vars
        .catch((_err) => {
          this.$toasted.error(
            'An error has occured while updating the message. Please try again.'
          )
        })
    }
  }
}
</script>
